import { Container, Button, Form, Alert, Modal, Table } from 'react-bootstrap';
import { Sida, Rubrik, ContentWrapper } from "../ContentStyles";
import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import MaterialReactTable from 'material-react-table';
import useBackend, { SpinnerX, Loading } from '../../services/useBackend_v2';
import { SplitoutLocalDateFromISO } from '../../services/misc';
import { FaRegCheckCircle, FaCreditCard } from 'react-icons/fa';

export default function Campaigns() {
    const { loading, data, Refresh, initReady, resultVisible, Check, setPagination, pagination } = useBackend('/api/admin/Campaigns');

    const navigate = useNavigate();

    const columns = useMemo(() => [
        { size: 40, accessorKey: 'Name', header: 'Name' },
        { size: 20, header: 'Startdatum'           , enableColumnActions: false,
            Cell: ({ row }) => ( <span>{SplitoutLocalDateFromISO(row.original.StartDate)}</span> ),
        }, 
        { size: 20, header: 'Slutdatum'           , enableColumnActions: false,
            Cell: ({ row }) => ( <span>{SplitoutLocalDateFromISO(row.original.EndDate)}</span> ),
        },
        {
            size: 20, header: 'Aktiv', enableOrdering: true, enableColumnOrdering: true, enablePinning: true, enableColumnActions: false,
            Cell: ({ row }) => (<>{row.original.Active && <FaRegCheckCircle />}</>),
        },
        {
            size: 20, header: 'Endast medlemmar', enableOrdering: true, enableColumnOrdering: true, enablePinning: true, enableColumnActions: false,
            Cell: ({ row }) => (<>{row.original.onlyPrio && <FaRegCheckCircle />}</>),
        },

        {
            size: 20, header: 'Rabatt', enableOrdering: true, enableColumnOrdering: true, enablePinning: true, enableColumnActions: false,
            Cell: ({ row }) => (<>{row.original.DiscountPercentage}%</>),
        },        



        { size: 40, accessorKey: 'Product.Name', header: 'Produkt' },
        { size: 40, accessorKey: 'ProductGroup.Name', header: 'Produktgrupp' },
        { size: 40, accessorKey: 'Shop.Name', header: 'Butik' },
        // { size: 40, accessorKey: 'Customer.Name', header: 'Kund' },
    ]
    );

    const initialState = { density: 'compact', columnVisibility: { 'Name': true, 'Startdatum': false, 'Slutdatum': true }, pagination: pagination };

    const state = { pagination: pagination };

    if (!loading) {
        return (
            <ContentWrapper> 
                <Container>
                    <Sida>
                        <MaterialReactTable columns={columns} data={data.Campaigns} onPaginationChange={setPagination} state={state} initialState={initialState}
                            muiTablePaginationProps={{ showFirstButton: false, showLastButton: false, labelRowsPerPage: "Rader" }}
                            renderTopToolbarCustomActions={() => (<Rubrik>Kampanjer</Rubrik>)}

                            muiTablePaperProps={{ elevation: 0, sx: { borderRadius: '0', border: '0px dashed #e0e0e0' } }}
                            muiTableBodyRowProps={({ row }) => ({
                                // onClick: (event) => { editProductHandler(event, row); }, sx: { cursor: 'pointer' },
                            })}
                        />
                    </Sida>
                </Container>
            </ContentWrapper>
        );
    } else {
        return (<Loading />);
    }
}